export default "__VITE_ASSET__BXZAZK8y__"